import { OnBlurCallback, OnChangeCallback } from '..';

import React from 'react';
import styled from '@emotion/styled';

import PanelRepeatable from './panel-repeatable';
import PanelSingle from './panel-single';

import { IElementSchema, IHiddenFields, FieldErrors, ICorrectionComment } from '../../../types/form';
import theme from '../../../theme';
import { MAX_PANEL_WIDTH_FORM_COMPONENT } from '../../../utils/form';

export type PanelProps = {
  name: string;
  path: string;
  elements: IElementSchema[];
  getFormData: (path: string) => any;
  fieldRenderer?: (
    type: string,
    attributes: any,
    error: any,
    Comp: React.ComponentType<any>,
    index?: number
  ) => React.ReactNode;
  value: any;
  errors: FieldErrors<Record<string, any>>;
  disabled: boolean;
  repeatable: boolean;
  isOrderedList?: boolean;
  canPopulateFromProfile?: boolean;
  hiddenFields: IHiddenFields;
  maxRepeatable?: number;
  onChange?: OnChangeCallback;
  onBlur?: OnBlurCallback;
  onVisibilityChange: (name: string, path: string) => void;
  onAddItem: (name: string, path: string, index: number) => void;
  onDeleteItem: (name: string, path: string, index: number) => void;
  correctionComments: ICorrectionComment[];
  setMultiDocUploadInProgress: (state: boolean) => void;
  multiDocUploadInProgress: boolean;
};

export const PanelContainer = styled.div`
  margin-bottom: 15px;
  border-radius: 4px;
  max-width: ${MAX_PANEL_WIDTH_FORM_COMPONENT}px;
  .has-error & {
    border: solid 1px ${theme.colorsErrorState100};
  }
`;

export default function Panel(props: PanelProps) {
  const { repeatable } = props;

  return repeatable ? <PanelRepeatable {...props} /> : <PanelSingle {...props} />;
}
